import { render, staticRenderFns } from "./Single-work.vue?vue&type=template&id=313bddd8&"
import script from "./Single-work.vue?vue&type=script&lang=js&"
export * from "./Single-work.vue?vue&type=script&lang=js&"
import style0 from "./Single-work.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports